import { render, staticRenderFns } from "./CompTabelaCdaAjuizada.vue?vue&type=template&id=09a1ba90&"
import script from "./CompTabelaCdaAjuizada.vue?vue&type=script&lang=js&"
export * from "./CompTabelaCdaAjuizada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports